(() => {
  "use strict";

  const STYLE_ID = "print-studio-canvas-polish";

  function installCanvasPolish() {
    document.getElementById(STYLE_ID)?.remove();

    const style = document.createElement("style");
    style.id = STYLE_ID;
    style.textContent = `
      .print-studio__frame.is-canvas::before {
        top: 2px !important;
        right: -4px !important;
        bottom: 2px !important;
        width: 4px !important;
        border-radius: 0 4px 4px 0 !important;
        transform: none !important;
        background: linear-gradient(90deg, var(--canvas-side), var(--canvas-edge)) !important;
        box-shadow: 3px 0 8px rgba(28,22,18,.08) !important;
      }

      .print-studio__frame.is-canvas::after {
        left: 3px !important;
        right: -2px !important;
        bottom: -4px !important;
        height: 4px !important;
        border-radius: 0 0 5px 5px !important;
        transform: none !important;
        background: linear-gradient(180deg, var(--canvas-edge), var(--canvas-side)) !important;
        box-shadow: 0 4px 8px rgba(28,22,18,.08) !important;
      }
    `;
    document.head.append(style);
  }

  if (window.customElements) {
    customElements.whenDefined("print-frame-studio").then(installCanvasPolish);
  } else {
    installCanvasPolish();
  }
})();
